module.exports = __webpack_public_path__ + "static/media/Magical Quest 3 (Nightfall) Trainer.429c7573.zip";


//////////////////
// WEBPACK FOOTER
// ./src/files/Magical Quest 3 (Nightfall) Trainer.zip
// module id = 279
// module chunks = 0